export default function(config, order) {
    ga(`${analytics.instancePrefix}require`, 'ecommerce')

    ga(`${analytics.instancePrefix}ecommerce:addTransaction`, {
        id: order.invoice_number,
        revenue: order.total,
        tax: order.tax - order.tax_discount,
    })

    let items = {}

    for (let item of order.items.data) {
        if (!config.excluded_product_types.includes(item.product.data.type)) {
            const sku = item.product.data.name
            if (sku in items) {
                items[sku].quantity += item.count || 1
            } else {
                items[sku] = {
                    id: order.invoice_number,
                    sku: sku,
                    name: item.product.data.name,
                    category: item.product.data.type,
                    price: item.single_price,
                    quantity: item.count || 1,
                }
            }
        }
    }

    items = Object.values(items)

    for (let item of items) {
        ga(`${analytics.instancePrefix}ecommerce:addItem`, item)
    }

    ga(`${analytics.instancePrefix}ecommerce:send`)
}
